import { Spinner } from "@mixitone/components";
import { ApplicationView } from "@mixitone/mvc";
import Form from "components/Forms/Form";
import FormButtons from "components/Forms/FormButtons";
import { ModalFormFieldset } from "components/Forms/FormRenderers/ModalFormRenderer";
import { TournamentPlayerFormController } from "components/Forms/TournamentPlayerForm";
import AppModal from "components/common/AppModal";
import { injectModal } from "lib/injectParams";
import { useMemo } from "react";

const TournamentPlayerForm = TournamentPlayerFormController.scope(
  ApplicationView(() => {
    const controller = TournamentPlayerFormController.use();
    const { loading } = controller.state;
    const fields = useMemo(
      () => Object.values(controller.fields()).filter((field) => field.group === "basic"),
      [],
    );

    if (loading) {
      return (
        <div className="flex items-center justify-center">
          <Spinner size={64} />
        </div>
      );
    }

    return (
      <Form name="player">
        <ModalFormFieldset fields={fields} />
        <FormButtons />
      </Form>
    );
  }),
);

const NewTournamentPlayerModal: React.FC<{ id: string }> = ({ id }) => {
  return (
    <AppModal title="Add player">
      <TournamentPlayerForm attributes={{ tournament_session_id: id }} />
    </AppModal>
  );
};

export default injectModal(ApplicationView(NewTournamentPlayerModal));
